import vraagAntwoord from '../pages/tests/vraagAntwoord.vue'
import comptest from '../pages/tests/comptest.vue'
import XVdateTest from '../pages/tests/XVdateTest.vue'
import multimain from '../pages/tests/multipagetest/main.vue'
import multicomp1 from '../pages/tests/multipagetest/multicomp1.vue'
import multicomp2 from '../pages/tests/multipagetest/multicomp2.vue'
import scrollsticky from '../pages/tests/Scrollsticky.vue'
import HtmlPDFGenerator from '../pages/tests/HtmlPDFGenerator.vue'
import wizard from '../pages/tests/wizard/wizard.vue'
import start from '../pages/tests/wizard/components/start.vue'
import cursustype from '../pages/tests/wizard/components/cursustype.vue'
import elearning from '../pages/tests/wizard/components/elearning.vue'
import klassikaal from '../pages/tests/wizard/components/klassikaal.vue'

export default [
  {
    path: '/peapp/HtmlPDFGenerator/',
    name: 'HtmlPDFGenerator',
    component: HtmlPDFGenerator
  },
  {
    path: '/peapp/scrollsticky/',
    name: 'scrollsticky',
    component: scrollsticky
  },
  {
    path: '/peapp/vraagAntwoord/',
    name: 'vraagAntwoord',
    component: vraagAntwoord
  },
  {
    path: '/peapp/comptest/',
    component: comptest
  },
  {
    path: '/peapp/comptest/:beroepsgroep',
    component: comptest
  },
  {
    path: '/peapp/XVdateTest/',
    component: XVdateTest
  },
  {
    path: '/peapp/public/multipage/',
    component: multimain,
    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /peapp/public/multipage/comp1  is matched
        path: 'comp1',
        component: multicomp1
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /peapp/public/multipage/comp2 is matched
        path: 'comp2',
        component: multicomp2
      }
    ],
    name: 'multimain'
  },
  {
    path: '/peapp/test/wizard',
    component: wizard,
    name: 'mywizard',
    children: [
      { path: 'start', component: start, name: 'start' },
      { path: 'cursustype', component: cursustype, name: 'cursustype' },
      { path: 'elearning', component: elearning, name: 'elearning' },
      { path: 'klassikaal', component: klassikaal, name: 'klassikaal' }
    ]
  }
  // Einde test router links lysanne
]
